import React, { Fragment, useCallback, useState, useEffect } from 'react'
import Button from '@material-ui/core/Button'
import TextField from '@material-ui/core/TextField'
import { makeStyles } from '@material-ui/core'
import { Auth } from '@aws-amplify/auth'
import LOG from '../../logging/Logger'

const useStyles = makeStyles(theme => ({
  textField: {
    marginLeft: theme.spacing(),
    marginRight: theme.spacing(),
    width: '100%'
  }
}))

function Profile({ signOut = () => {} }) {
  LOG.debug('Render: Profile')

  const classes = useStyles()

  const [email, setEmail] = useState([])
  const [signingOut, setSigningOut] = useState(false)

  const getUsername = useCallback(async () => {
    const currentUser = await Auth.currentAuthenticatedUser()
    setEmail(currentUser.attributes.email)
  }, [])

  const logout = useCallback(async () => {
    setSigningOut(true)
    await signOut()
    setSigningOut(false)
  }, [signOut])

  useEffect(() => {
    getUsername()
  }, [getUsername])

  return (
    <Fragment>
      <TextField
        id='email'
        label='Email'
        className={classes.textField}
        value={email}
        margin='normal'
        inputProps={{ 'aria-label': 'email', 'data-lpignore': 'true' }}
      />
      <br />
      <Button
        disabled={signingOut}
        variant='contained'
        color='primary'
        onClick={logout}
      >
        Sign Out
      </Button>
    </Fragment>
  )
}

export default Profile
